import { createContext, useContext, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from "@uidotdev/usehooks";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  // const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);
    <Navigate to="/"/>
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    // navigate("/login", { replace: true });
    <Navigate to="/login" replace/>
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};